// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

common.View.create('website_blog::canvas.blocks.modules.blog.Block', {
    swiperInstance: null,

    onDOMLoad() {
        this.initSwiperOnResize();
        this.setupResizeListener();
        this.setupLivewireListener();
    },

    initSwiperOnResize() {
        const blogSwiperEl = document.querySelector('.blogSwiper');
        if (!blogSwiperEl) return;

        const isMobile = window.innerWidth < 768;

        // If mobile and not initialized, create swiper
        if (isMobile && !this.swiperInstance) {
            // Get fresh button reference each time
            const nextButton = blogSwiperEl.querySelector('.swiper-button-next');

            this.swiperInstance = new Swiper(blogSwiperEl, {
                slidesPerView: 1,
                spaceBetween: 16,
                centeredSlides: false,
                observer: true,
                observeParents: true,
                observeSlideChildren: true,
                navigation: {
                    nextEl: nextButton,
                },
                breakpoints: {
                    320: {
                        slidesPerView: 1.2,
                        spaceBetween: 16,
                    },
                    480: {
                        slidesPerView: 1.2,
                        spaceBetween: 24,
                    },
                },
            });
        }
        // If desktop and initialized, destroy swiper
        else if (!isMobile && this.swiperInstance) {
            this.swiperInstance.destroy(true, true);
            this.swiperInstance = null;
        }
    },

    setupResizeListener() {
        let resizeTimeout;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                this.initSwiperOnResize();
            }, 100);
        });
    },

    setupLivewireListener() {
        // Listen for Livewire updates (filtering)
        Livewire.hook('morph.updated', () => {
            // Destroy existing swiper instance
            if (this.swiperInstance) {
                this.swiperInstance.destroy(true, true);
                this.swiperInstance = null;
            }

            // Reinitialize after a short delay to let DOM settle
            setTimeout(() => {
                this.initSwiperOnResize();
            }, 50);
        });
    },
});
